import axios from "axios"
import { ticketBaseURL } from "../configs/api";

export const post_RdRentalCreditCard = async (data: any, userId: number) => {
    const response = await axios({
        url: `${ticketBaseURL}rdRentalCreditCard?userId=${userId}`,
        method: "POST",
        headers: {          
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const put_RdRentalCreditCard = async (data: any, userId: number) => {
    const response = await axios({
        url: `${ticketBaseURL}rdRentalCreditCard?userId=${userId}`,
        method: "PUT",
        headers: {           
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const delete_RdRentalCreditCard = async (primaryKey: number, userId: number) => {
    const response = await axios({
        url: `${ticketBaseURL}rdRentalCreditCard`,
        method: "DELETE",      
        params: {
            id: primaryKey,
            userId
        }
    });
    return response.data;
}

export const getRdRentalCreditCards = () => {
    return getFetch("rdRentalCreditCard")
}

export const getRdRentalCreditCard = (primaryKey: string) => {
    return getFetch(`rdRentalCreditCard/${primaryKey}`)
}

export const getRdRentalCreditCardWithTenantIdAndIsActive = (tenantId: string) => {
    return getFetch(`rdRentalCreditCard/GetRdRentalCreditCardByTenantIdAndIsActiveWithValidExpiryDate/${tenantId}`)
}

export const getRdRentalCreditCardWithTenantId = (tenantId: string, page: number, size: number) => {
    return getFetch(`rdRentalCreditCard/GetRdRentalCreditCardsPagingByTenantId/${tenantId},${page},${size}`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: ticketBaseURL + url,
        method: "GET",       
        params: params
    }).then(response => response.data);
}